import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";

const icons = {
  DashboardOutlinedIcon,
};

const allDashBoard = {
  id: "group-dashboard",
  title: "Navigation",
  type: "dashboard",
  children: [
    {
      id: "dashboard",
      title: "Dashboard",
      type: "is_access_to_dashboard",
      url: "/",
      icon: icons.DashboardOutlinedIcon,
      breadcrumbs: false,
    },
  ],
};

export default allDashBoard;
